export const cardsInfo = [
    {
        id:1,
        name: '¿Qué estudié?',
        data: 'lo que estudié (me sigo capacitando constantemente)',
        category: 'studies',
        img: '/assets/images/estudios.svg'
    },
    {
        id: 2,
        name: 'Mi experiencia',
        data: 'acerca de mi experiencia laboral',
        category: 'experiences',
        img: '/assets/images/experiencia.svg'
    },
    {
        id: 3,
        name: 'Info sobre mi',
        data: 'mi',
        category: 'about',
        img: '/assets/images/sobreMi.svg'
    },
    {
        id: 4,
        name: 'Mis skills',
        data: 'los lenguajes y herramientas que sé usar',
        category: 'skills',
        img: '/assets/images/skills.svg'
    },
    {
        id: 5,
        name: 'Mis proyectos',
        data: 'los proyectos que realicé o estoy realizando',
        category: 'projects',
        img: '/assets/images/proyectos.svg'
    }
    
]

export const getAll = ( data ) => {
    return new Promise ( (res ) => {
        setTimeout (() => {
            res(data)
        }, 500)
    })

}
